import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import { Section } from 'components';
import withWaypointsContainer from 'components/WayPoint/Container/HOC';
import { enableAnimations } from 'config/helpers';
import {
  MainBanner,
  NewsSlider,
  WhatWeDo,
  Approach,
  Work,
  ContactBoxes,
  Culture,
  About,
  Statistics,
} from './subcomponents';

class HomePage extends Component {
  static propTypes = {
    entryViews: PropTypes.array.isRequired,
    leaveViews: PropTypes.array.isRequired,
    clearActiveViews: PropTypes.func.isRequired,
  };

  componentDidMount() {
    enableAnimations();
    window.addEventListener('beforeunload', this.sendPathBeforeUnload);
  }

  componentWillUnmount() {
    this.sendPathSequenceEvent();
    window.removeEventListener('beforeunload', this.sendPathBeforeUnload);
  }

  sendPathBeforeUnload = e => {
    if (e.srcElement.activeElement !== document.body) {
      return;
    }
    this.sendPathSequenceEvent();
  };

  sendPathSequenceEvent() {
    if (
      typeof window === 'undefined' ||
      typeof window.dataLayer === 'undefined'
    ) {
      return;
    }

    const { entryViews, leaveViews, clearActiveViews } = this.props;

    const views = leaveViews.filter(lv => lv.timeSpent >= 2);
    if (entryViews.length) {
      views.push(entryViews[entryViews.length - 1]);
    }

    let pathSequence = '';

    views.forEach(v => {
      pathSequence = pathSequence ? `${pathSequence}=>${v.path}` : `${v.path}`;
    });

    clearActiveViews();

    if (pathSequence) {
      window.dataLayer.push({
        event: 'userPath',
        eventCategory: 'User Path Tracking',
        pathSequence,
      });
    }
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            officeBackground: file(
              relativePath: { eq: "office/office-6.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1898) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div style={{ overflow: 'hidden' }}>
            <MainBanner />

            <Section color={'gray-light'} id={'work'}>
              <Work />
            </Section>

            <Section color={'violet'} spaceless>
              <NewsSlider />
            </Section>

            <Section id={'services'} color={'mine-shaft'} fullwidth spaceless>
              <WhatWeDo />
            </Section>

            <Section id={'approach'} fullwidth spaceless>
              <Approach />
            </Section>

            <Section id={'about'} color={'gray-light'} stick spaceless>
              <About />
            </Section>

            <Section id={'statistics'} color={'mine-shaft'}>
              <Statistics />
            </Section>

            <Section id={'culture'} color={'gray-light'} stick spaceless>
              <Culture />
            </Section>

            <Section
              background={data.officeBackground.childImageSharp.fluid.src}
              fullwidth
              spaceless
            />

            <Section id={'contact'} spaceless>
              <ContactBoxes />
            </Section>
          </div>
        )}
      />
    );
  }
}

export default withWaypointsContainer(HomePage);
